module.exports = __webpack_public_path__ + "static/media/treasure.c1201023.png";